<div
	fxLayout="row"
	fxLayoutAlign="start center"
	fxLayoutGap="0.25rem"
	class="bid-contact-actions"
	[class.bid-contact-actions--compact]="compact"
>
	<!-- CN-8619: phone fires tel: AND opens the "Log a call" modal. -->
	<a
		*ngIf="phone"
		[href]="'tel:' + phone"
		mat-icon-button
		color="primary"
		[attr.aria-label]="phoneTooltip"
		[matTooltip]="phoneTooltip"
		(click)="$event.stopPropagation(); openLogCallDialog()"
	>
		<mat-icon>phone</mat-icon>
	</a>
	<!-- CN-8940: in compact mode an absent action holds its slot open so the icons
	     stay in column alignment down the table. The dedicated Contact column on
	     Quote Details keeps collapsing them instead. -->
	<span *ngIf="!phone && compact" class="bid-contact-actions__slot" aria-hidden="true"></span>

	<!-- CN-8619: email fires mailto: AND opens the "Log a call" modal. -->
	<a
		*ngIf="email"
		[href]="'mailto:' + email"
		mat-icon-button
		color="primary"
		[attr.aria-label]="emailTooltip"
		[matTooltip]="emailTooltip"
		(click)="$event.stopPropagation(); openLogCallDialog()"
	>
		<mat-icon>email</mat-icon>
	</a>
	<span *ngIf="!email && compact" class="bid-contact-actions__slot" aria-hidden="true"></span>

	<button
		mat-icon-button
		color="primary"
		matTooltip="Log Call"
		aria-label="Log call"
		(click)="$event.stopPropagation(); openLogCallDialog()"
	>
		<!-- CN-8619: match the "Log call" icon used across the app (carrier outreach
		     / Procurement Projects) so the action reads consistently. -->
		<mat-icon>edit_note</mat-icon>
	</button>
</div>
